import { Base } from './Base';

export class NewsArticle extends Base {
    title: string;
    description: string;
    url: string;
    provider: string;
    category: string;
    images: NewsImage[];
    datePublished: Date;

    constructor(i?: INewsArticle) {
        super();
        if (i){
            Object.assign(this, i);
            this.datePublished = new Date(i.datePublished);
        }
    }

    toInterface(): INewsArticle {
        const ret = {} as INewsArticle;
        Object.assign(ret, this);
        return ret;
    }
}

export interface INewsArticle {
    title: string;
    description: string;
    url: string;
    provider: string;
    category: string;
    images: NewsImage[];
    datePublished: Date;
}

export interface NewsImage {
    url: string;
    width: number;
    height: number;
}
